import {getInternalHrefPath} from '@toolify/client/src/modules/routes/functions/getInternalHrefPath'
import {getInternalLinkHosts} from '@toolify/client/src/modules/internalLinks/functions/getInternalLinkHosts'

export function getInternalPathFromAnchor(anchor: HTMLAnchorElement): string | null {
  const href = anchor.getAttribute('href')
  if(!href) {
    return null
  }
  return getInternalHrefPath(href, {
    baseHref: window.location.href,
    currentHost: window.location.host,
    internalHosts: getInternalLinkHosts(),
  })
}
